import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

function ProjectPage() {
  return (
    <body>
      <h1 className='project-heading'> Projects </h1>
      <div>
           <div className='project-position project-animate'>
          <img src='./pictures/strudel.png' className='project-image' alt="strudel"></img>
          <div className="project-title">
            <h1> Strudel </h1>
            {/* The description of the project */}
          <div className='project-description'>
            <p> Strudel is a university coursework project that explores live-coded music. Users can follow the technical manual to learn how to create music through code:<a href="https://patterns.slab.org/technical-manual/repl/">Strudel</a>
            </p>
            <div className='project-tech'>
              <span> ReactJS </span>
              <span> TailwindCSS </span>
              <span> Strudel reactor </span>
            </div>
            <div>
              <a href="https://github.com/DangKhoaNguyen-110400489/strudel_reactor" target="_blank" rel="noopener noreferrer" className='project-view'> View  <FontAwesomeIcon icon={faArrowRight} className='icon'/> </a>
            </div>
          </div>
          </div>
        </div>

        <div className='project-position'>
          <img src='./pictures/pawpals-design.png' className='project-image' alt="pawpals"></img>
          <div className="project-title">
            <h1> Pawpals </h1>
            {/* The description of the project */}
          <div className='project-description'>
            <p>Pawpals is created to find the lost pet. The website is using an AI to detect the similar image and then
              send an email to the user for announce them that the pet is found. The website is using HTML/CSS, Python (flask),
              AWS S3, and CNN Model.</p>
            <div className='project-tech'>
              <span> Python (flask) </span>
              <span> HTML/CSS </span>
              <span> AWS S3 </span>
            </div>
            <div>
              <a href="https://github.com/Dang-Khoa-Nguyen/Pawpals.git" target="_blank" rel="noopener noreferrer" className='project-view'> View  <FontAwesomeIcon icon={faArrowRight} className='icon'/> </a>
            </div>
          </div>
          </div>
          
        </div>

        <div className='project-position'>
          <img src='./pictures/myFinFriend.png' className='project-image' alt="myFinFriend"></img>
          <div className="project-title">
            <h1> myFinFriend </h1>
            {/* The description of the project */}
          <div className='project-description'>
            <p>myFinFriend is created to allow the users to have a friend that can manage the finances efficiently in each month, each week, or each quarter. 
              (In-progress) 
            </p>
            <div className='project-tech'>
              <span> Python (flask) </span>
              <span> ReactJS </span>
              <span> TailwindCSS </span>
              <span> google-genai </span>
            </div>
            <div>
              <a href="https://github.com/huynhphihoang/myFinFriend/tree/main" target="_blank" rel="noopener noreferrer" className='project-view'> View  <FontAwesomeIcon icon={faArrowRight} className='icon'/> </a>
            </div>
          </div>
          </div>
        </div>

        <div className='project-position'>
          <img src='./pictures/menuMentor.png' className='project-image' alt="MenuMentor"></img>
          <div className="project-title">
            <h1> MenuMentor </h1>
            {/* The description of the project */}
          <div className='project-description'>
            <p> MenuMentor is created to help manager introduce the food that they may like and categories the food that is be chosen most in the restaurant. (In-progress) </p>
            <div className='project-tech'>
              <span> Python (flask) </span>
              <span> ReactJS </span>
              <span> TailwindCSS </span>
              <span> Open-ai </span>
            </div>
            <div>
              <a href="https://github.com/Dang-Khoa-Nguyen/MenuMentor" target="_blank" rel="noopener noreferrer" className='project-view'> View  <FontAwesomeIcon icon={faArrowRight} className='icon'/> </a>
            </div>
          </div>
          </div>
        </div>
      </div>
    </body>
  );
}

export default ProjectPage;